module.exports = __webpack_public_path__ + "img/trimed.c3c464f7.jpg";